import { inject, observer } from 'mobx-react';
import React, { Fragment, useEffect, useRef } from 'react';
import { STORE_PHONE_CALL } from '../../../../../constants/stores';
import { SoftphoneAudiosProps } from './types';
const incomingCallsMp3 =
  require('../../../../../assets/audio/IncomingCalls.mp3') as HTMLAudioElement['src'];
const outgoingCallsMp3 =
  require('../../../../../assets/audio/OutgoingCalls.mp3') as HTMLAudioElement['src'];
const secondIncomingCallMp3 =
  require('../../../../../assets/audio/OnCallIncomingChime.mp3') as HTMLAudioElement['src'];
const callDisconnectedMp3 =
  require('../../../../../assets/audio/CallDisconnected.mp3') as HTMLAudioElement['src'];
const lostConnectionMp3 =
  require('../../../../../assets/audio/LostConnection.mp3') as HTMLAudioElement['src'];

const SoftphoneAudios = (props: SoftphoneAudiosProps) => {
  const { phoneCall: phoneStore } = props;
  const remoteAudio = useRef<HTMLAudioElement>(null);
  const ringTone = useRef<HTMLAudioElement>(null);
  const incomingTone = useRef<HTMLAudioElement>(null);
  const secondIncomingTone = useRef<HTMLAudioElement>(null);
  const lostConnectionTone = useRef<HTMLAudioElement>(null);
  const callDisconnectedTone = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    phoneStore.setLocalRemoteAudio(remoteAudio.current);
    phoneStore.setLocalRingTone(ringTone.current);
    phoneStore.setLocalIncomingTone(incomingTone.current);
    phoneStore.setSecondLocalIncomingtone(secondIncomingTone.current);
    phoneStore.setLocalLostConnectionTone(lostConnectionTone.current);
    phoneStore.setLocalCallDisconnectedTone(callDisconnectedTone.current);
  }, []);

  return (
    <Fragment>
      <audio
        key="mainRemoteAudio"
        ref={(elem: HTMLAudioElement | null) => (remoteAudio.current = elem)}
        id="mainRemoteAudio"
      />
      <audio
        key="ringtone"
        ref={(elem: HTMLAudioElement | null) => (ringTone.current = elem)}
        src={incomingCallsMp3}
        id="ringtone-audio"
        preload="auto"
      />
      <audio
        key="secondIncomingtone"
        ref={(elem: HTMLAudioElement | null) =>
          (secondIncomingTone.current = elem)
        }
        src={secondIncomingCallMp3}
        id="secondIncomingtone-audio"
        preload="auto"
      />
      <audio
        key="incomingtone"
        ref={(elem: HTMLAudioElement | null) => (incomingTone.current = elem)}
        src={outgoingCallsMp3}
        id="incomingtone-audio"
        preload="auto"
      />
      <audio
        key="callDisconnected"
        ref={(elem: HTMLAudioElement | null) =>
          (callDisconnectedTone.current = elem)
        }
        src={callDisconnectedMp3}
        id="callDisconnected-audio"
        preload="auto"
      />
      <audio
        key="lostConnection"
        ref={(elem: HTMLAudioElement | null) =>
          (lostConnectionTone.current = elem)
        }
        src={lostConnectionMp3}
        id="lostConnection-audio"
        preload="auto"
      />
    </Fragment>
  );
};

export default inject(STORE_PHONE_CALL)(observer(SoftphoneAudios));
